<template>
  <el-dialog
    v-model="dialogVisible"
    :title="title"
    class="settings-modal settings-modal--compact" align-center @open="onDialogOpen">
    <el-form
      @submit.prevent
      ref="form"
      :model="form"
      status-icon
      label-width="auto"
    >
      <el-form-item prop="name"
                    :rules="[{ required: true, message: 'Обязательно для заполнение'}]">
        <el-input ref="cityInput"  placeholder="Название города" v-model="form.name" type="text" autocomplete="off" @keyup.enter="submitForm" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">Отмена</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="submitForm"
        >
          {{ form.id ? 'Обновить' : 'Добавить' }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { ElMessage } from 'element-plus'
import store from '@/components/store/store'

export default {
  name: 'AddCity',
  data() {
    return {
      form: {
        id: null,
        name: ''
      },
      title: 'Добавить город',
      button: 'Добавить',
      dialogVisible: false,
      loading: false
    }
  },
  methods: {
    onDialogOpen() {
      this.$nextTick(() => {
        this.$refs.cityInput.focus();
      });
    },
    open() {
      this.dialogVisible = true
      this.form.id = null
      this.form.name = ''
    },
    edit(item) {
      this.form = JSON.parse(JSON.stringify(item))
      this.dialogVisible = true
      this.title = 'Редактировать ' + item.name
    },
    async createCity() {
      this.loading = true
      try {
        await this.$refs.form.validate()
      } catch (e) {
        ElMessage.error('Заполните необходимые поля')
        this.loading = false
        return
      }
      await store.dispatch('cities/addCity', { name: this.form.name })
      this.loading = false
      this.dialogVisible = false
    },
    async updateCity() {
      this.loading = true
      try {
        await this.$refs.form.validate()
      } catch (e) {
        ElMessage.error('Заполните необходимые поля')
        this.loading = false
        return
      }
      await store.dispatch('cities/updateCity', { id: this.form.id, name: this.form.name })
      this.loading = false
      this.dialogVisible = false
    },
    submitForm() {
      this.form.id ? this.updateCity() : this.createCity();
    },
  }
}
</script>


<style scoped>

</style>
